import { useTranslations } from "next-intl";
import { useCurrentUser } from "@hooks/use-current-user";
import Button from "@components/core/Button";
import Link from "@components/core/LinkApp";
import DrawerIcon from "@components/views/Drawer/DrawerIcon";
import { useOpenDrawer } from "@hooks/use-drawer";

function NavbarCTAHandler() {
  const t = useTranslations("common");

  const openDrawer = useOpenDrawer();
  const user = useCurrentUser();
  const userState = user?.state;
  const restartAtDate = user?.subscription?.restart_at;

  function displayRedirectTunnelButton(title, href) {
    return (
      <Link href={href}>
        <Button
          size="sm"
          style={{ zIndex: 2 }}
          className="px-3"
        >
          {title}
        </Button>
      </Link>
    );
  }

  function displayOpenDrawerButton() {
    return (
      <Button
        size="sm"
        style={{ zIndex: 2 }}
        onClick={openDrawer}
      >
        {t("navbar.restart")}
      </Button>
    );
  }

  function displayButton() {
    switch (userState) {
      case "lead":
        return displayRedirectTunnelButton(t("navbar.i_begin"), "/je-commence");
      case "subscriber":
        return <DrawerIcon />;
      case "suspended":
        if (restartAtDate) return displayOpenDrawerButton();

        return displayRedirectTunnelButton(t("navbar.restart"), "/je-commence");
      default:
        return displayRedirectTunnelButton(t("navbar.i_begin"), "/je-commence");
    }
  }

  return displayButton();
}

export default NavbarCTAHandler;
